import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Dashboard from './components/dashboard/Dashboard';
import PurchaseManagement from './components/purchases/PurchaseManagement';
import SalesManagement from './components/sales/SalesManagement';
import TransportationManagement from './components/transportation/TransportationManagement';
import CrateManagement from './components/crates/CrateManagement';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import UserProfile from './components/auth/UserProfile';
import ContactsManagement from './components/contacts/ContactsManagement';
import ContactDetails from './components/contacts/ContactDetails';
import CreateOrder from './components/sales/CreateOrder';
import OrderDetailsPage from './components/sales/OrderDetailsPage';
import BusinessSettings from './components/settings/BusinessSettings';
import FinalizeSale from './components/sales/FinalizeSale';

import { ThemeProvider } from 'styled-components';
import { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import Loader from './components/Loader';

// Wrap protected routes with Layout component
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <Loader />;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return <Layout>{children}</Layout>;
};

function App() {
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem('darkMode') === 'true'
  );

  return (
    <AuthProvider>
      <ThemeProvider theme={{ mode: darkMode ? 'dark' : 'light' }}>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />


            {/* Protected routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/purchases"
              element={
                <ProtectedRoute>
                  <PurchaseManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales/*"
              element={
                <ProtectedRoute>
                  <Routes>
                    <Route index element={<SalesManagement />} />
                    
                    <Route path="create" element={<CreateOrder />} />
                    <Route path="order/:orderId" element={<OrderDetailsPage />} />
                    <Route path="finalize/:orderId" element={<FinalizeSale />} />
                  </Routes>
                </ProtectedRoute>
              }
            />
            <Route
              path="/transportation"
              element={
                <ProtectedRoute>
                  <TransportationManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crates"
              element={
                <ProtectedRoute>
                  <CrateManagement />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/*"
              element={
                <ProtectedRoute>
                  <ContactsManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/:type/:id"
              element={
                <ProtectedRoute>
                  <ContactDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings/business"
              element={
                <ProtectedRoute>
                  <BusinessSettings />
                </ProtectedRoute>
              }
            />

            {/* Redirect all other routes to login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;